



export default function Footer() {
    // states



    // comportements



    // affichage
    return (
        <footer className="sticky-footer bg-white">
            <div className="container my-auto">
                <div className="copyright text-center my-auto">
                    <span>Copyright &copy; NAS & WLC 2024</span>
                </div>
            </div>
        </footer>
    )
}